import React, { Component }
    from 'react';
import { Redirect }
    from "react-router-dom";
import logo_img from './../assets/images/Muvi_Logo_Blue_White.svg';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';

class Resetpassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newpassword: '',
            repassword: '',
            redirect: false,
            message: '',
            fields: [],
            errors: {},
            isLoggedIn: false,
            incorrect_password: '',
            expired_link: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            er_url: window.location.href
        }
        this.resetPassword = this.resetPassword.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        console.log(this.state.fields);
        if (!fields["newpassword"]) {
            formIsValid = false;
            errors["newpassword"] = "Type your password.";
        }
        else if (fields["newpassword"] && !this.isValidPassword(fields["newpassword"])) {
            formIsValid = false;
            errors["newpassword"] = "Invalid Password!";
        }
        else if (!fields["repassword"]) {
            formIsValid = false;
            errors["repassword"] = "Re-type your password.";
        }
        else if (fields["repassword"] != fields["newpassword"]) {
            formIsValid = false;
            errors["repassword"] = "The password doesn't match. Enter the correct password";
        }
        else if (fields["repassword"] && !this.isValidPassword(fields["repassword"])) {
            formIsValid = false;
            errors["repassword"] = "Invalid Password!";
        }

       

        this.setState({ errors: errors });
        return formIsValid;
    }

    isValidPassword(pass) {
        // var pattern = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,30}$/;
        var pattern = /^(?=.*[0-9])(?=.*[!"#$%&'()*+,-\./\:;<=>\?@[\]^_`{|}~\\])[a-zA-Z0-9!"#$%&'()*+,-\./\:;<=>\?@[\]^_`{|}~\\]{8,}$/;
        return pattern.test(pass);
    }

    resetPassword() {
        if (this.handleValidation()) {
            document.getElementById("login_btn").disabled = true;
            fetch(this.state.apiUrl + '/site/ResetPassword/hashkey/' + this.props.match.params.hashkey, {

                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })

                .then((response) => response.json())
                .then((result) => {
                    result = this.decrypt(result, 1);
                    console.log(result);
                    if (result.code == 200) {
                        document.getElementById("login_btn").disabled = true;
                        window.location.href = '/login';
                    }else if (result.code == 500) {
                        this.setState({message: result.msg});
                        document.getElementById("login_btn").disabled = false;
                    } else if (result.code == 400) {
                        this.setState({message: result.msg});
                        document.getElementById("login_btn").disabled = true;
                    }
                })
        } else {
            console.log("This Fields Are required.")
            return false;
        }
    }
    HashkeyValid() {
            fetch(this.state.apiUrl + '/site/HashkeyValid/hashkey/' + this.props.match.params.hashkey, {

                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })

                .then((response) => response.json())

                .then((result) => {
                    result = this.decrypt(result, 1);
                    console.log(result);

                  {/*if (result.code == 500) {
                        window.location.href = '/NoAccess';
                    }*/}  
                })
    }

    onChange(e) {
        let fields = this.state.fields;
        this.setState({ [e.target.name]: e.target.value });
        fields[e.target.name] = e.target.value;
        this.setState({errors:''});
    }

    componentDidMount() {
        this.HashkeyValid();
        // alert(this.props.match.params.hashkey)
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/home'} />
            )
        }
        if (localStorage.getItem('userLogin')) {
            return (
                <Redirect to={'/home'} />
            )
        }
        return (
            <div class="limiter">
                <div class="logo">
                    <a href="#"><img src={logo_img} /></a>
                </div>
                <div class="container-login100">
                    <div class="wrap-login">
                        <div class="login100-form validate-form">
                            <form action="javascript:void(0);" onSubmit={() => this.resetPassword()}>
                                <span class="login100-form-title">
                                    Reset Password
                    </span>

                                <span class="color-sky">
                                    Password must contain atleast 8 characters with atleast a special character and a number
                    </span>
                                <div class="wrap-input100" data-validate="Username is required">

                                    <input type="password" name="newpassword" placeholder="Type your new password here" class="input100" onChange={
                                        this.onChange} />
                                    <span class="error">{this.state.errors["newpassword"]}</span>
                                </div>


                                <div class="wrap-input100 validate-input" data-validate="Password is required">

                                    <input type="password" name="repassword" placeholder="Re-type your new password" class="input100" onChange={
                                        this.onChange} />
                                    <span class="error">{this.state.errors["repassword"]}</span>
                                    <span className="error"> {
                                        this.state.message}</span>
                                </div>
                                          
                                <div class="container-login100-form-btn">
                                    <button type="submit" id="login_btn" class="login100-form-btn btn btn-sky" >Reset Password</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default Resetpassword;



// WEBPACK FOOTER //
// ./src/components/Resetpassword.js